<footer class="m-grid__item m-footer ">
    <div class="m-container m-container--fluid m-container--full-height m-page__container">
        <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
            <div class="m-stack__item m-stack__item--left">
                <span class="m-footer__copyright" style="color: black !important;">
                    Cable Pro Web
                     <br />
                    <span>Version {{appSession.application.version}} [{{releaseDate |   date:"dd/MM/yy"}}]</span><br />
                </span>
            </div>
            <div class="m-stack__item--middle">
                <span class="m-footer__copyright">
                    <a class="f-mail" href="mailto:support@elek.com">Email: support&#64;elek.com </a>
                    <br />
                    <a href="https://elek.com/privacy/" target="_blank">Privacy</a> &nbsp; <a href="https://elek.com/terms/" target="_blank">Terms</a>
                </span>
            </div>

            <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
                <a href="https://elek.com" target="_blank">
                    <img style="height:40px;" src="assets/anonymouspage/images/Elek-Footer-Color.png" alt="Electrotechnik Pty Ltd">
                </a>
            </div>
        </div>
    </div>
</footer>
